import { useState } from "react";
import { Search, Bell, ChevronDown, Menu, LogOut } from "lucide-react";

export default function Topbar({ onOpenMobile, user, onLogout }) {
  const [menu, setMenu] = useState(false);
  const name = user?.name || "Super Admin";
  const role = (user?.role || "").replace("_", " ");
  const initials = name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  return (
    <header className="sticky top-0 z-20 flex h-[68px] items-center gap-3 border-b border-[#EAE1D3] bg-white/70 px-4 backdrop-blur-xl md:px-6" data-testid="admin-topbar">
      {/* Mobile menu */}
      <button
        onClick={onOpenMobile}
        className="rounded-md p-2 text-[#5C5449] hover:bg-[#F5F1E8] lg:hidden"
        data-testid="admin-mobile-menu-btn"
        aria-label="Open menu"
      >
        <Menu size={20} />
      </button>

      {/* Search */}
      <div className="relative flex-1 max-w-xl">
        <Search size={17} className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-[#A79C8A]" />
        <input
          type="text"
          placeholder="Search users, requests, content"
          data-testid="admin-global-search"
          className="h-10 w-full rounded-lg border border-[#E9E2D6] bg-[#FAFAF5] pl-10 pr-16 font-body text-sm text-[#2C241B] outline-none transition-colors placeholder:text-[#A79C8A] focus:border-[#E0A98F] focus:bg-white"
        />
        <span className="pointer-events-none absolute right-3 top-1/2 hidden -translate-y-1/2 items-center gap-1 rounded-md border border-[#E9E2D6] bg-white px-1.5 py-0.5 font-body text-[11px] text-[#A79C8A] sm:flex">
          ⌘ K
        </span>
      </div>

      {/* Right */}
      <div className="ml-auto flex items-center gap-2">
        <button className="relative rounded-lg p-2 text-[#5C5449] hover:bg-[#F5F1E8]" data-testid="admin-notifications" aria-label="Notifications">
          <Bell size={18} />
          <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-[#D84315] ring-2 ring-white" />
        </button>
        <div className="relative">
          <button onClick={() => setMenu((m) => !m)} className="flex items-center gap-2.5 rounded-lg py-1 pl-1 pr-2 hover:bg-[#F5F1E8]" data-testid="admin-profile-menu">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-[#E86A3A] to-[#BF360C] font-body text-xs font-semibold text-white shadow-[0_4px_12px_-4px_rgba(216,67,21,0.8)]">{initials}</span>
            <span className="hidden text-left leading-tight sm:block">
              <span className="block font-body text-[13px] font-semibold text-[#2C241B]">{name}</span>
              <span className="block font-body text-[11px] capitalize text-[#8A8072]">{role}</span>
            </span>
            <ChevronDown size={15} className="hidden text-[#A79C8A] sm:block" />
          </button>
          {menu && (
            <>
              <div className="fixed inset-0 z-10" onClick={() => setMenu(false)} />
              <div className="absolute right-0 z-20 mt-2 w-52 rounded-xl border border-[#E9E2D6] bg-white p-1.5 shadow-lg" data-testid="admin-profile-dropdown">
                <div className="px-3 py-2">
                  <p className="truncate font-body text-sm font-semibold text-[#2C241B]">{name}</p>
                  <p className="truncate font-body text-xs text-[#8A8072]">{user?.email}</p>
                </div>
                <button onClick={onLogout} data-testid="admin-logout"
                  className="flex w-full items-center gap-2 rounded-lg px-3 py-2 font-body text-sm text-[#C62828] hover:bg-[#FDECEA]">
                  <LogOut size={15} /> Sign out
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
